import React from "react"
import { CampProps } from "~/interfaces"

const PaymentDisclaimer = ({ camp }: { camp: CampProps }) => {
  return (
    <div className="mt-2.5 mb-8 text-sm">
      By submitting this form, I agree to{" "}
      {camp.rules && (
        <>
          the{" "}
          <a
            href={`/camps/${camp.slug}/rules`}
            target="_blank"
            className="text-blue-500 hover:text-blue-400 underline hover:underline"
          >
            Rules at {camp.name}
          </a>{" "}
          and{" "}
        </>
      )}
      authorize this payment to the campground via{" "}
      <a
        href="https://stripe.com/checkout/legal"
        target="_blank"
        className="text-blue-500 hover:text-blue-400 underline hover:underline"
      >
        Stripe
      </a>
      .
    </div>
  )
}

export default PaymentDisclaimer
